import { render, staticRenderFns } from "./Explanation1.vue?vue&type=template&id=56a280d0&scoped=true&lang=pug&"
import script from "./Explanation1.vue?vue&type=script&lang=ts&"
export * from "./Explanation1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a280d0",
  null
  
)

export default component.exports